const shopUrl = window.__GGShopUrl || '';

export function sendAvailabilityNotification(
    email: string,
    articleNumber: string,
    onSuccess: (newInfoText: string) => void,
    onError?: (errorMessages: string) => void,
    onFailure?: (error: any) => void,
) {
    fetch(`${shopUrl}/ggarticlenotification`, {
        method: 'post',
        body: JSON.stringify({ email, articleNumber }),
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.sErrorMessages) {
                console.error('Could not send data to article notification endpoint');

                if (onError && typeof onError === 'function') {
                    onError(json.sErrorMessages);
                }
            } else if (json.success === true) {
                onSuccess(json.infoTextToUser);
            }
        })
        .catch((error) => {
            console.error('Server failure while sending data to article notification endpoint', error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
}
